/**
 * The single place any surface asks "has the customer configured this
 * integration?", keyed by entitlement key. Absent means not configured, which
 * hides the surface — the conformance test is what stops that being caused by
 * missing coverage rather than a real answer.
 *
 * Configured is not healthy: an integration whose target is down stays visible.
 */
export function isIntegrationConfigured(summary: { configured?: Record<string, boolean> } | null | undefined, integrationKey: string) {
  return summary?.configured?.[integrationKey] === true
}

